export default __webpack_public_path__ + "static/media/baloes.75ec9b81.png";